function defineNamespace(implementation) {
  return { ...implementation, [Symbol.onexus.namespace]: true };
}
function defineFunction(handler) {
  return handler;
}
function defineEvent(...listeners) {
  return { [Symbol.onexus.event]: { listeners } };
}
function defineStore(detail, start) {
  return { [Symbol.onexus.event]: { detail, start } };
}
export {
  defineEvent,
  defineFunction,
  defineNamespace,
  defineStore
};
